import type { CardType } from '@pushflow/types'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { userSettingsAtom } from '../../../store/atoms'
import {
  ECardBack,
  ECardType,
  ETableColor,
} from '../../../store/atoms/userSettings'
import { Card } from '../../atoms'
import {
  cardBlock,
  cardInDeck,
  cardThemeDeck,
  colorBlock,
  settingOption,
  settingsBlock,
  settingsContent,
  settingVariants,
} from './index.css'

export const TableSettings = () => {
  const { t } = useTranslation()
  const [userSettings, setUserSettings] = useAtom(userSettingsAtom)

  return (
    <div className={settingsBlock}>
      <div className={settingsContent}>
        <div className={settingOption}>
          <span>{t('settings.setting.tableColor')}</span>
          <div className={settingVariants}>
            {Object.values(ETableColor).map((color) => (
              <span
                key={color}
                className={colorBlock}
                style={{
                  backgroundColor: color,
                  borderColor:
                    userSettings.tableSettings.tableColor === color
                      ? 'white'
                      : undefined,
                  boxShadow:
                    userSettings.tableSettings.tableColor === color
                      ? '0px 0px 4px 1px white'
                      : undefined,
                }}
                onClick={() =>
                  setUserSettings((old) => ({
                    ...old,
                    tableSettings: {
                      ...old.tableSettings,
                      tableColor: color,
                    },
                  }))
                }
              />
            ))}
          </div>
        </div>
      </div>

      <div className={settingsContent}>
        <div className={settingOption}>
          <span>{t('settings.setting.cardsBack')}</span>
          <div className={settingVariants}>
            {Object.values(ECardBack).map((cardBack) => (
              <span
                key={cardBack}
                onClick={() =>
                  setUserSettings((old) => ({
                    ...old,
                    tableSettings: {
                      ...old.tableSettings,
                      cardsBack: cardBack,
                    },
                  }))
                }
              >
                <Card
                  className={cardBlock}
                  value='null'
                  cardBack={cardBack}
                  style={{
                    boxShadow:
                      userSettings.tableSettings.cardsBack === cardBack
                        ? '0px 0px 4px 1px white'
                        : undefined,
                  }}
                />
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className={settingsContent}>
        <div className={settingOption}>
          <span>{t('settings.setting.cardsType')}</span>
          <div className={settingVariants}>
            {Object.values(ECardType).map((cardType) => (
              <span
                key={cardType}
                className={cardThemeDeck}
                style={{
                  opacity:
                    userSettings.tableSettings.cardsType === cardType ? 1 : 0.7,
                  boxShadow:
                    userSettings.tableSettings.cardsType === cardType
                      ? '0px 0px 4px 2px white'
                      : undefined,
                }}
                onClick={() =>
                  setUserSettings((old) => ({
                    ...old,
                    tableSettings: {
                      ...old.tableSettings,
                      cardsType: cardType,
                    },
                  }))
                }
              >
                {(['dA', 'hA', 'sA', 'cA'] as CardType[]).map((card, index) => {
                  return (
                    <Card
                      key={card}
                      className={cardInDeck}
                      value={card}
                      theme={cardType}
                      style={
                        index !== 0
                          ? { transform: `translateX(-${50 * index}%)` }
                          : undefined
                      }
                    />
                  )
                })}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
